import { render } from "./ModalClientDanRegional.vue?vue&type=template&id=c0a7b76a&scoped=true&ts=true"
import script from "./ModalClientDanRegional.vue?vue&type=script&lang=ts"
export * from "./ModalClientDanRegional.vue?vue&type=script&lang=ts"

import "./ModalClientDanRegional.vue?vue&type=style&index=0&id=c0a7b76a&lang=css&scoped=true"

import exportComponent from "/codebuild/output/src1651641719/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0a7b76a"]])

export default __exports__